import jsonrpc from "jsonrpc-lite"
import { createJsonRPCRequest, parseSchema } from "./utils"
import { v4 } from 'uuid';
import z from 'zod'

export const authMe = async () => {
    const data = jsonrpc.request(v4(), 'access_point.auth.me', {})
    return createJsonRPCRequest(data, parseSchema(() => z.any()))
}